/* ====================================================================
   COLETTE DEMAY · v2 motion script
   - Word-by-word reveal for [data-split]
   - IntersectionObserver-driven .is-visible on .reveal-up / .reveal-blur /
     .split-words / .obsessions / .larme-video-wrap / .notebook / .notebook-frame / .np-final
   - Set stroke-dasharray length per-SVG-path from getTotalLength
   ==================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Split [data-split] text nodes into <span class="word"> wrappers
  document.querySelectorAll('[data-split]').forEach(function (el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    el.classList.add('split-words');
    // Walk only direct text-bearing children; preserve <em>, <br>
    var html = el.innerHTML;
    // Replace <br> markers temporarily
    html = html.replace(/<br\s*\/?>/gi, '|||BR|||');
    // Split into tokens by spaces but keep tags intact (simple tokenizer)
    var tokens = html.split(/(\s+)/);
    var out = tokens.map(function (t) {
      if (!t.trim()) return t;
      // tokens may contain <em>foo</em> — wrap whole token
      return '<span class="word">' + t + '</span>';
    }).join('');
    out = out.replace(/\|\|\|BR\|\|\|/g, '<br>');
    el.innerHTML = out;
    // Set per-word transition delay
    var words = el.querySelectorAll('.word');
    var step = reduce ? 0 : 0.06;
    words.forEach(function (w, i) {
      w.style.transitionDelay = (i * step) + 's';
    });
  });

  // 2) Precompute stroke length for [data-draw] / [data-draw-fast]
  function setDrawLen(el) {
    try {
      var len = el.getTotalLength ? el.getTotalLength() : 0;
      if (len && isFinite(len)) {
        el.style.setProperty('--draw-len', len);
      }
    } catch (e) { /* element not yet measurable */ }
  }
  function refreshAllDrawLens() {
    document.querySelectorAll('[data-draw], [data-draw-fast]').forEach(setDrawLen);
  }
  // Run after fonts & layout settle
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refreshAllDrawLens);
  }
  window.addEventListener('load', refreshAllDrawLens);

  // 3) IntersectionObserver for all reveal targets
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  var selectors = [
    '.reveal-up', '.reveal-blur', '.split-words',
    '.obsessions', '.larme-video-wrap',
    '.notebook', '.notebook-frame', '.np-final'
  ];
  document.querySelectorAll(selectors.join(',')).forEach(function (el) {
    io.observe(el);
  });

  // 4) Subtle parallax on .notebook (very gentle — feels like a page being held)
  if (!reduce) {
    var nb = document.querySelector('.notebook');
    if (nb) {
      var raf = null;
      function update() {
        var r = nb.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = Math.max(-0.2, Math.min(1.2, (vh - r.top) / (r.height + vh)));
        var ty = (0.5 - p) * 10; // ±5px max
        nb.style.transform = 'translateY(' + ty.toFixed(2) + 'px)';
        raf = null;
      }
      window.addEventListener('scroll', function () {
        if (raf == null) raf = requestAnimationFrame(update);
      }, { passive: true });
      update();
    }
  }
})();
